(function () {
    'use strict';

    var app = angular.module('inoApp');

    app.factory('userInfoEndpointService', ['$http', 'config', userInfoEndpointServiceFactory]);

    function userInfoEndpointServiceFactory($http, config) {

        var service = {
            getProfile: getProfile
        };

        return service;

        function getProfile() {
            // Get information about the user from the UserInfoEndpoint of our identity server.
            return $http.get(config.servicesUrl.identity.userInfoEndpoint).then(
                function (response) {
                    return response.data;
                },
                function (response) {
                    return {};
                });
        }
    }
})();